import { Injectable, signal } from '@angular/core';

import { UiToastState, UiToastType } from './ui-toast.types';

@Injectable({ providedIn: 'root' })
export class UiToastService {
  readonly toast = signal<UiToastState | null>(null);

  show(type: UiToastType, title: string, message: string, durationMs = 3000): void {
    this.toast.set({ type, title, message, durationMs });
  }

  success(title: string, message: string, durationMs?: number): void {
    this.show('success', title, message, durationMs);
  }

  info(title: string, message: string, durationMs?: number): void {
    this.show('info', title, message, durationMs);
  }

  warning(title: string, message: string, durationMs?: number): void {
    this.show('warning', title, message, durationMs);
  }

  error(title: string, message: string, durationMs?: number): void {
    this.show('error', title, message, durationMs);
  }

  created(entityName: string, message?: string): void {
    this.success(`${entityName} added`, message ?? `${entityName} was added successfully.`);
  }

  updated(entityName: string, message?: string): void {
    this.success(`${entityName} updated`, message ?? `${entityName} was updated successfully.`);
  }

  deleted(entityName: string, message?: string): void {
    this.success(`${entityName} deleted`, message ?? `${entityName} was removed successfully.`);
  }

  exported(entityName: string, message?: string): void {
    this.success(`${entityName} exported`, message ?? `${entityName} export completed successfully.`);
  }

  dismiss(): void {
    this.toast.set(null);
  }
}
